import { log } from "../../../common/Logging"

export enum TobaccoTourStages {
    CIGARETTE,
    ECIG,
    CHEW,
    FINISHED,
}

export class TobaccoTourProgressStore {
    private static innerInstance: TobaccoTourProgressStore

    tobaccoCompletedStages: Array<TobaccoTourStages> = []

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static destroy() {
        return (this.innerInstance = null)
    }

    static get stagesComplete(): boolean {
        return (
            TobaccoTourProgressStore.instance.cigStageFinished &&
            TobaccoTourProgressStore.instance.ecigStageFinished &&
            TobaccoTourProgressStore.instance.chewStageFinished
        )
    }

    get cigStageFinished(): boolean {
        return this.tobaccoCompletedStages.includes(TobaccoTourStages.CIGARETTE)
    }

    get chewStageFinished(): boolean {
        return this.tobaccoCompletedStages.includes(TobaccoTourStages.CHEW)
    }

    get ecigStageFinished(): boolean {
        return this.tobaccoCompletedStages.includes(TobaccoTourStages.ECIG)
    }

    get reviewComplete(): boolean {
        return this.tobaccoCompletedStages.includes(TobaccoTourStages.FINISHED)
    }

    setReviewComplete = () => {
        if (!this.tobaccoCompletedStages.includes(TobaccoTourStages.FINISHED)) {
            this.tobaccoCompletedStages.push(TobaccoTourStages.FINISHED)
        }
    }

    addStage = (stage: TobaccoTourStages) => {
        if (!this.tobaccoCompletedStages.includes(stage)) {
            this.tobaccoCompletedStages.push(stage)
        }
        log.debug(JSON.stringify(this.tobaccoCompletedStages))
    }
}
